const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaParceiro: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'USUARIO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'USUARIO_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };

		case 'USUARIO_PARCEIRO_SELECT_LISTADO':
			return {
				...state,
				listaParceiro: action.payload.data
			};

        default:
            return state;
    }
}
